export default {
  DeviceType: Object.freeze({
    android: 'Android',
    ios: 'Ios'
  }),
  PaymentType: Object.freeze({
    card: 'card',
    phone: 'phone',
    baeminPay: 'baeminPay',
    payco: 'payco'
  }),
  BrowserType: Object.freeze({
    chrome: 'chrome',
    safari: 'safari',
    ie: 'ie'
  })
}
